import React from 'react';
import { Box, Keyboard, TextInput } from 'grommet';
import {
    IconSearch
} from '@tabler/icons-react';
import Icon from './Icon';
// Abstract class for CustomerTagInput and InvoiceTagInput
const GenericTagInput = ({
    value = [],
    onAdd,
    onChange,
    onRemove,
    label,
    inputText,
    hideInput,
    renderValue,
    showSearchIcon=true,
    ...rest
}) => {
    const boxRef = React.useRef();

    const updateCurrentTag = (event) => {
        onChange && onChange(event);
    };

    const onAddTag = (newTag) => {
        if (onAdd) {
            onAdd(newTag);
        }
    };

    return (
        <Keyboard>
            <Box>
                <Box
                    direction="row"
                    align="center"
                    ref={boxRef}
                    wrap
                    pad="xxsmall"
                >
                    {showSearchIcon && value && value.length === 0 && (
                        <Box margin={{right: 'xsmall'}}>
                            <Icon SelectedIcon={IconSearch} size="xsmall" color="text-xweak" />
                        </Box>
                    )}
                    {value.length > 0 && renderValue(value, onRemove)}
                    {!hideInput && (
                        <Box flex width={{min: 'xsmall'}}>
                            <TextInput
                                type="search"
                                dropTarget={boxRef.current}
                                onChange={updateCurrentTag}
                                value={inputText}
                                onSuggestionSelect={(event) => onAddTag(event.suggestion.value)}
                                plain="full"
                                focusIndicator={false}
                                {...rest}
                            />
                        </Box>
                    )}
                </Box>
            </Box>
        </Keyboard>
    );
};

export default GenericTagInput;
